import { render, staticRenderFns } from "./m-block-empty-table.vue?vue&type=template&id=0baca398&scoped=true&lang=pug"
import script from "./m-block-empty-table.vue?vue&type=script&lang=js"
export * from "./m-block-empty-table.vue?vue&type=script&lang=js"
import style0 from "./m-block-empty-table.vue?vue&type=style&index=0&id=0baca398&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0baca398",
  null
  
)

export default component.exports